import * as React from 'react';
import cn from 'classnames';
const { Badge } = require('@cvent/carina-tags');

const _styles = require('./BadgeButton.scss');

export interface BadgeButtonProps {
    label: string;
    badgeCount: number;
    badgeCountActiveOnly?: boolean;
    onClick?: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
    isActive: boolean;
}

/**
 * A button that has a label and a badge that shows if badgeCount > 0
 */
export default (props: BadgeButtonProps) => {
    const showBadge = props.badgeCount > 0;

    return (
        <button
            className={cn(_styles.button, { [_styles.buttonWithBadge]: showBadge }, { [_styles.isActive]: props.isActive })}
            onClick={(e) => props.onClick && props.onClick(e)}
        >
            <div className={_styles.label}>{props.label}</div>
            {showBadge && <div className={_styles.badge}>{!props.badgeCountActiveOnly && <Badge content={`${props.badgeCount}`} />}</div>}
        </button>
    );
};
